








import { Prop, Component, Vue } from 'vue-property-decorator';
import { Avatar } from 'element-ui';

@Component({
  components: {
    'el-avatar': Avatar
  }
})
export default class AvatarIcon extends Vue {
  @Prop({ type: String }) avatarUrl?: string | null;
  @Prop({ type: String }) name?: string | null;
  @Prop({ default: 'small', type: [Number, String] }) size!: number | string;
  @Prop({ default: 'text-xs', type: String }) fontClass?: string;
}
